import "./style.css";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { ArrowUpIcon, EditClientIcon } from "components/Icons";
import clientProfileImage from "assets/icons/default_avater.svg";
import ThreeDots from "components/Spinners/ThreeDots";
import { FiShoppingBag, FiCalendar } from "react-icons/fi";
import { LiaHorseHeadSolid } from "react-icons/lia";
import { formatName } from "../../utils";
import { useAuthStore } from "../../stores/auth/authStore";


export default () => {
  const user = useAuthStore((state) => state.user);
  const isClientDataLoading = useAuthStore((state) => state.isLoading);
  const [isProfileLinksVisible, setIsProfileLinksVisible] = useState(false);
  const profileLinksRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileLinksRef.current &&
        !profileLinksRef.current.contains(event.target)
      ) {
        setIsProfileLinksVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileLinksRef]);

  const onArrowUpClick = () => {
    setIsProfileLinksVisible(!isProfileLinksVisible);
  };


  if (isClientDataLoading)
    return <ThreeDots fill="white" height={50} width={50} />;

  return (
    user && (
      <>
        <div
          onClick={onArrowUpClick}
          className={`cursor-pointer flex gap-[17px] items-center`}
        >
          {user?.photo ? (
            <img
              src={user?.photo}
              className="w-[28px] h-[28px] rounded-full object-contain"
            />
          ) : (
            <img
              src={clientProfileImage}
              alt="clientProfileImage"
              className="w-[28px] h-[28px] rounded-full object-contain"
            />
          )}
          <span className="capitalize name-style" >
            {formatName(
              user?.firstName + " " + user?.lastName
            )}
          </span>
          <div className="relative" ref={profileLinksRef}>
            <div className="cursor-pointer">
              <ArrowUpIcon />
            </div>
            {isProfileLinksVisible && (
              <div
                className={`profile_links absolute right-0 top-3 mt-2 py-2 w-[160px] bg-white rounded-md shadow-xl z-20 ${isProfileLinksVisible ? "block" : "hidden"
                  }`}
              >
                <Link
                  to={"user/horses"}
                  className="flex pl-3 items-center gap-3 hover:bg-gray-100"
                >
                  <LiaHorseHeadSolid size={20} color="#5C80B6" />
                  <span className="client-links block  py-2 text-[12px] text-sm text-gray-700 hover:bg-gray-100">
                    My Horses
                  </span>
                </Link>
                <Link
                  to={"/my-bookings"}
                  className="flex pl-3 items-center gap-3 hover:bg-gray-100"
                >
                  <FiCalendar size={20} color="#5C80B6" />
                  <span className="client-links block  py-2 text-[12px] text-sm text-gray-700 hover:bg-gray-100">
                    My Bookings
                  </span>
                </Link>
                <Link
                  to={"/my-orders"}
                  className="flex pl-3 items-center gap-3 hover:bg-gray-100"
                >
                  <FiShoppingBag size={20} color="#5C80B6" />
                  <span className="client-links block  py-2 text-[12px] text-sm text-gray-700 hover:bg-gray-100">
                    My Orders
                  </span>
                </Link>
                <Link
                  to={"/profile"}
                  className="flex pl-3 items-center gap-3 hover:bg-gray-100"
                >
                  <EditClientIcon className="!text-transparent" />
                  <span className="client-links block  py-2 text-[12px] text-sm text-gray-700 hover:bg-gray-100">
                    Update Profile
                  </span>
                </Link>
              </div>
            )}
          </div>
        </div>
      </>
    )
  );
};


